import SectionContent from './SectionContent'

export default SectionContent
